import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/miniCalculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'dates';

/**
 * Dates Mini Calculator Endpoints:
 */
export default {
    /**
     * Period Between Two Dates Calculation Endpoint.
     *
     * @param  {} dates
     *
     * @return {Promise}
     */
    PeriodBetweenTwoDates(dates) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'period-between-two-dates', {
            start_date: dates.firstDate,
            end_date: dates.secondDate,
            options: dates.options
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/api/mini-calculators/dates.js